<template>
  <div class="sass_home">
    <div class="banner_box">
      <img src="@/assets/img/saas/banner1.png" />
      <div class="botton_box">
        <div class="button" @click="openTpt(1)"
          v-if='(!orderList[0] || (orderList[0] && orderList[0].currentState == "1"))'>免费使用</div>
        <div class="button button1" v-if='orderList[0] && orderList[0].currentState > 1' @click="experienceNow()">立即体验
        </div>
      </div>
      <div class="order_box" v-if="orderList.length > 0">
        <div class="left">
          <img class="icon" src="@/assets/img/saas/saas1-icon.png" />
          <span class="title">我的工单</span>
          <span class="content">工单编号：{{ orderList[0].workOrderNumber }}</span>
          <span class="content" style='margin-left:20px;'>联系人：{{ orderList[0].contactName }}</span>
          <span class="content" v-if="orderList[0].inviteCode" style='margin-left:20px;'>邀请码：{{ orderList[0].inviteCode
            }}</span>
          <span class="status">
            <div class="spot spot1" v-if="orderList[0].currentState == '1' || orderList[0].currentState == '2'"></div>
            <div class="spot" v-if="orderList[0].currentState == '3'"></div>
            {{ orderList[0].currentStateStr }}
          </span>
        </div>
        <div class="right" @click="openTptOrder" v-if="orderList[0].serviceAddress && defaultCompanyId">
          <span class="title">前往TPT</span>
          <span class="right-icon"><i class="el-icon-arrow-right"></i></span>
        </div>
      </div>
    </div>
    <div class="page2">

      <div class="title_box">
        <div class="top">
          <div class="line"></div>
          <div class="title">平台介绍</div>
          <div class="line"></div>
        </div>
        <div class="bottom">PLATFORM INTRODUCE</div>
      </div>
      <div class="platform_box">
        <img class="icon" src="@/assets/img/saas/saas1-news.png" />
        <div class="content">
          时序大模型TPT是中控技术自主研发的基于生成式AI算法及海量工业数据训练而成的流程工业时序大模型。时序大模型TPT通过统一分析类、优化类、控制类、培训类等工业建模过程，实现装置的跨工况、高精度、高可靠模拟与预测，从而解决数据碎片化、工业应用分散等难题，构建以一个模型为基座，打造一个软件支撑多种应用的新模式。时序大模型TPT作为“智慧大脑”使装置像专家一样自主思考与交流，自我监督和自主优化运行，已在氯碱、热电、石化等行业的多个装置上取得了突破性应用，解决了众多复杂控制、操作优化和异常预警等问题，实现了提人效、稳运行、增收益的目标，将全面引领流程工业加速“智变”。
        </div>
      </div>
      <div class="title_box">
        <div class="top">
          <div class="line"></div>
          <div class="title">视频介绍</div>
          <div class="line"></div>
        </div>
        <div class="bottom">VIDEO INTRODUCE</div>
      </div>
      <div class="video_box">
        <!-- :autoplay="false" -->
        <video id="myVideo" class="video-js vjs-default-skin vjs-big-play-centered" controls
          oncontextmenu="return false" controlsList="nodownload" preload="auto" muted="true"
          style="width: 1190px;height: 448px;cursor: pointer;"
          :poster="videoPath + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_1190,h_448,m_fast'">
          <source :src="videoPath" type="video/mp4">
        </video>
      </div>
      <div class="title_box">
        <div class="top">
          <div class="line"></div>
          <div class="title">版本选型</div>
          <div class="line"></div>
        </div>
        <div class="bottom">EDITION SELECTION</div>
      </div>
      <div class="edition_box">
        <div class="list">
          <div class="top top1">SaaS版</div>
          <ul>
            <li>工艺参数预测预警</li>
            <li>设备异常状态识别</li>
            <li>生产效率实时评价</li>
            <li>装置指标灵活计算</li>
            <div class="line"></div>
            <li>生产知识培训及AI考试</li>
            <li>生产数据AI分析</li>
            <li>装置总览报告AI生成</li>
            <div class="line"></div>
            <li>支持单装置500点数据</li>
            <li>云化部署</li>
          </ul>
          <div class="button" @click="openTpt(2)"
            v-if='(!orderList[0] || (orderList[0] && orderList[0].currentState == "1"))'>免费使用<img
              src="@/assets/img/saas/right.png" /></div>
          <div class="button buttonDisabled" v-else-if="defaultCompanyId">已使用</div>
        </div>
        <div class="list">
          <div class="top top2">标准版</div>
          <ul>
            <li class="colorGreen">离线操作优化</li>
            <li>工艺参数预测预警</li>
            <li>设备异常状态识别</li>
            <li>生产效率实时评价</li>
            <li>装置指标灵活计算</li>
            <div class="line"></div>
            <li>生产知识培训及AI考试</li>
            <li>生产数据AI分析</li>
            <li>装置总览报告AI生成</li>
            <div class="line"></div>
            <li class="colorGreen">支持单装置5000点数据</li>
            <li class="colorGreen">云化部署/私有化部署</li>
            <li class="colorGreen">移动端应用</li>
          </ul>
          <div class="button button1" @click="openTpt(3)" v-if="defaultCompanyId">立即购买<img
              src="@/assets/img/saas/right.png" /></div>
        </div>
        <div class="list">
          <div class="top top3">高阶版</div>
          <ul>
            <li class="colorOrange">在线实时优化</li>
            <li class="colorOrange">复杂过程优化控制</li>
            <li class="colorOrange">工艺仿真与AI操作演练</li>
            <li class="colorOrange">PID参数优化整定</li>
            <li class="colorOrange">控制性能评估</li>
            <li>工艺参数预测预警</li>
            <li>设备异常状态识别</li>
            <li>生产效率实时评价</li>
            <li>装置指标灵活计算</li>
            <div class="line"></div>
            <li>生产知识培训及AI考试</li>
            <li>生产数据AI分析</li>
            <li>装置总览报告AI生成</li>
            <div class="line"></div>
            <li class="colorOrange">支持单装置10000点数据</li>
            <li class="colorOrange">私有化部署/云边协同部署</li>
            <li class="colorOrange">移动端应用</li>
          </ul>
          <div class="button button2" @click="openTpt(4)" v-if="defaultCompanyId">立即购买<img
              src="@/assets/img/saas/right.png" /></div>
        </div>
      </div>
      <div class="title_box">
        <div class="top">
          <div class="line"></div>
          <div class="title">行业应用</div>
          <div class="line"></div>
        </div>
        <div class="bottom">INDUSTRY APPLICATION</div>
      </div>
      <ul class="industry_box">
        <li>
          <img class="icon" src="@/assets/img/saas/saas1-sector4.png" />
          <div>氯碱装置</div>
        </li>
        <li>
          <img class="icon" src="@/assets/img/saas/saas1-sector5.png" />
          <div>热电装置</div>
        </li>
        <li>
          <img class="icon" src="@/assets/img/saas/saas1-sector6.png" />
          <div>重整装置</div>
        </li>
      </ul>
      <div class="title_box">
        <div class="top">
          <div class="line"></div>
          <div class="title">功能演示</div>
          <div class="line"></div>
        </div>
        <div class="bottom">FUNCTION DEMO</div>
      </div>
      <div class="video_box">
        <!-- :autoplay="false" -->
        <video id="myVideo" class="video-js vjs-default-skin vjs-big-play-centered" controls
          oncontextmenu="return false" controlsList="nodownload" preload="auto" muted="true"
          style="width: 1190px;height: 653px;cursor: pointer;"
          :poster="videoPath1 + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_1190,h_653,m_fast'">
          <source :src="videoPath1" type="video/mp4">
        </video>
      </div>
    </div>

  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import { openOther } from '@/utils'
import { getAccessToken } from "@/utils/userInfo";
import {
  USER_AUTH_COMPANY_MODAL,
} from "@/components/authCompany/helper";

export default {
  data() {
    return {
      videoPath: 'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/TPT/TPT_CN.mp4',
      videoPath1: 'https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/TPT/TPT.mp4',
      orderList: [],
      defaultCompanyId: ''

    }
  },
  methods: {
    // 试用表单页：${host}/tpt-business-web/out/info/test?code=${code}
    // sass版本：${host}/tpt-business-web/out/info/test?code=${code}
    // 标准版：${host}/tpt-business-web/out/info/buy/standard?code=${code}
    // 高阶版：${host}/tpt-business-web/out/info/buy/advanced?code=${code}
    openTpt(type) {
      if(!this.defaultCompanyId){
        this.bus.$emit(USER_AUTH_COMPANY_MODAL,'该功能模块限企业用户专享，请先认证企业：')
        return
      }
      const token = getAccessToken();
      if (!token) {
        this.$router.push({ name: "login" });
        return;
      }
      this.$http
        .get(`/inter/thirdPartyAuth/getAuthCode?client_id=TPT`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            let url = ''
            if (type === 1 || type === 2) { // 试用表单页 sass版
              url = `${res.data.redirectUrl.split('/home/main')[0]}/out/info/test?code=${res.data.code}`
            } else if (type === 3) { // 标准版
              url = `${res.data.redirectUrl.split('/home/main')[0]}/out/info/buy/standard?code=${res.data.code}`
            } else if (type === 4) { // 高阶版
              url = `${res.data.redirectUrl.split('/home/main')[0]}/out/info/buy/advanced?code=${res.data.code}`
            }
            window.open(url, "_blank");
          }
        });
    },
    // 立即体验
    experienceNow() {
      const token = getAccessToken();
      if (!token) {
        this.$router.push({ name: "login" });
        return;
      }
      this.$http
        .get(`/inter/thirdPartyAuth/getAuthCode?client_id=TPT`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            let url = ''
            url = `${res.data.redirectUrl.split('/tpt-business-web')[0]}/supgpt-app/#/login?source=S2B`
            window.open(url, "_blank");
          }
        });

    },
    // 获取订单
    getOrderList() {
      const token = getAccessToken();
      if (!token) {
        return;
      }
      this.$http
        .get(`/inter/thirdPartyAuth/getTptApplyInfo`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.orderList = res.data
          }
        })
        .catch(() => { })
    },
    // 创建工单打开
    openTptOrder() {
      openOther(this.orderList[0].serviceAddress, true)
    },
    watchPage() {
      let that = this
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          // console.log('页面被隐藏');
          // 在这里执行相应的操作，例如暂停动画、减少定时器频率等
        } else {
          // console.log('页面可见');
          that.getOrderList()
          // 在这里执行相应的操作，例如恢复动画、增加定时器频率等
        }
      });
    }
  },
  mounted() {
    this.getOrderList()
    this.watchPage()
    this.defaultCompanyId = localStorage.getItem('defaultCompanyId') || ''
    this.bus.$on('companyResetRefresh', val => {
      this.getOrderList()
    })
  }
}
</script>
<style lang="scss" scoped>
.sass_home {
  .page2 {
    width: 1190px;
    margin: 0 auto;
    padding: 40px 0 100px;
  }

  .banner_box {
    position: relative;

    img {
      width: 100%;
      height: auto;
    }

    .botton_box {
      position: absolute;
      left: calc((100% - 1190px) / 2);
      display: flex;
      justify-content: flex-start;
      bottom: 80px;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 140px;
      height: 54px;
      background: linear-gradient(135deg, #5ECBF7 0%, #347FF7 100%);
      border-radius: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      cursor: pointer;
      margin-right: 20px;

      &:hover {
        background: linear-gradient(135deg, #86d6f5 0%, #7ea8eb 100%);
      }

      &:active {
        background: linear-gradient(135deg, #5ECBF7 0%, #347FF7 100%);
      }

      img {
        width: 14px;
        margin-left: 5px;
      }
    }

    .button1 {
      border: solid 2px #347FF7;
      color: #347FF7;
      background: rgba(255, 255, 255, .7);

      &:hover {
        background: rgba(255, 255, 255, .5);
      }

      &:active {
        background: rgba(255, 255, 255, .7);
      }
    }

    .order_box {
      background-color: #fff;
      width: 1190px;
      height: 72px;
      position: absolute;
      left: calc((100% - 1190px) / 2);
      bottom: -36px;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .icon {
          width: 32px;
          margin: 0 10px 0 20px;
        }

        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #1572F3;
          margin-right: 36px;
        }

        .content {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #333333;
        }

        .status {
          display: flex;
          justify-content: start;
          align-items: center;
          font-size: 18px;
          color: #333333;

          .spot {
            width: 8px;
            height: 8px;
            background: #27BB7A;
            border-radius: 50%;
            margin: 0 10px 0 36px;
          }

          .spot1 {
            background: orange;
          }
        }
      }

      .right {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;

        .title {
          width: 70px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #1572F3;

          &:hover {
            color: rgb(88, 152, 241);
          }

          &:active {
            color: #1572F3;
          }
        }

        .right-icon {
          font-size: 18px;
          color: #999999;
          margin-left: 10px;
        }
      }
    }
  }

  .title_box {
    text-align: center;
    margin: 60px 0;

    .top {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 700;

      .line {
        width: 70px;
        height: 2px;
        background-color: #2F6CC4;
      }

      .title {
        color: #2F6CC4;
        margin: 0 20px;
        font-weight: 600;
        font-size: 24px;
      }
    }

    .bottom {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #666666;
      margin-top: 10px;
    }
  }

  .platform_box {
    width: 1190px;
    height: 372px;
    background: #F8F8F8;
    border-radius: 8px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .icon {
      width: 526px;
    }

    .content {
      width: 532px;
      height: 300px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 32px;
      text-align: justify;
      font-style: normal;
    }
  }

  .edition_box {
    display: flex;
    justify-content: space-between;

    .list {
      width: 380px;
      height: 780px;
      background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.4);
      border-radius: 4px;
      position: relative;

      .top {
        height: 100px;
        line-height: 100px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 24px;
        color: #333333;
        text-align: left;
        padding-left: 28px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .top1 {
        background-image: url('../../../../assets/img/saas/saas1-sector1.png');
      }

      .top2 {
        background-image: url('../../../../assets/img/saas/saas1-sector2.png');
      }

      .top3 {
        background-image: url('../../../../assets/img/saas/saas1-sector3.png');
      }

      ul {
        padding: 20px 40px 20px 50px;

        li {
          list-style: disc !important;
          position: relative;
          font-size: 16px;
          margin-bottom: 6px;
          font-weight: 500;
          color: #666666;
          font-family: PingFangSC, PingFang SC;
        }

        li::after {
          position: absolute;
          content: '';
          color: #999999;
          right: -10px;
          width: 13px;
          height: 13px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-image: url('../../../../assets/img/saas/success.svg');
        }

        li::marker {
          color: #B2B1B1;
          font-size: 20px;
        }

        .colorGreen {
          color: #04d866;
        }

        .colorOrange {
          color: #f18706;
        }

        .line {
          height: 1px;
          background: #DDDDDD;
          margin: 10px -9px 10px -19px;
        }
      }

      .button {
        position: absolute;
        left: calc((100% - 312px) / 2);
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 30px;
        width: 312px;
        height: 54px;
        border-radius: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        cursor: pointer;
        background: linear-gradient(135deg, #5ECBF7 0%, #347FF7 100%);

        &:hover {
          background: linear-gradient(135deg, #86d6f5 0%, #7ea8eb 100%);
        }

        &:active {
          background: linear-gradient(135deg, #5ECBF7 0%, #347FF7 100%);
        }

        img {
          width: 14px;
          margin-left: 15px;
        }
      }

      .buttonDisabled {
        background: linear-gradient(135deg, #58595a 0%, #232324 100%);

        &:hover {
          background: linear-gradient(135deg, #58595a 0%, #232324 100%);
        }

        &:active {
          background: linear-gradient(135deg, #58595a 0%, #232324 100%);
        }
      }

      .button1 {
        background: linear-gradient(135deg, #6CD99F 0%, #2ABC6E 100%);
        ;

        &:hover {
          background: linear-gradient(135deg, #ade4c6 0%, #7cdaa8 100%);
        }

        &:active {
          background: linear-gradient(135deg, #6CD99F 0%, #2ABC6E 100%);
          ;
        }
      }

      .button2 {
        background: linear-gradient(135deg, #E7A85B 0%, #EC8D1A 100%);

        &:hover {
          background: linear-gradient(135deg, #f3d0a3 0%, #ecb97b 100%);
        }

        &:active {
          background: linear-gradient(135deg, #E7A85B 0%, #EC8D1A 100%);
          ;
        }
      }

    }

  }

  .industry_box {
    display: flex;
    justify-content: space-between;

    li {
      width: 380px;
      height: 250px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }

      div {
        position: absolute;
        left: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 48px;
        color: #fff;
        text-align: center;
        line-height: 48px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
      }
    }
  }
}
</style>
